const placeholders = {
  quill: {
    sk: 'Vložte poznámku ...',
    cz: 'Vložte poznámku ...',
    en: 'Insert note ...'
  },
  geocoder: {
    sk: 'Vyhľadať',
    cz: 'Vyhledat',
    en: 'Search'
  },
  elevChart: {
    sk: {
      elevChart: 'Graf prevýšenia trate'
    },
    cz: {
      elevChart: 'Graf převýšení tratě'
    },
    en: {
      elevChart: 'Evevation chart'
    }
  }
}

export { placeholders }



//////////////////
// WEBPACK FOOTER
// ./static/localization/placeholders.js
// module id = 199
// module chunks = 1